const API_CONFIG = {
  // Properly construct base URL with /api suffix
  BASE_URL: (() => {
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
    // Ensure the URL ends with /api for consistent behavior
    return baseUrl.endsWith('/api') ? baseUrl : `${baseUrl}/api`;
  })(),
  
  // Remove API_PREFIX since it's now included in BASE_URL
  TIMEOUT: 30000,
  
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  
  ENDPOINTS: {
    // Auth endpoints
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    REFRESH_TOKEN: '/auth/refresh',
    
    // User endpoints
    USERS: '/users',
    CURRENT_USER: '/users/current',
    
    // Product endpoints
    PRODUCTS: '/products',
    PRODUCT_CATEGORIES: '/product-categories',
    PRODUCT_UNITS: '/product-units',
    TAX_RATES: '/tax-rates',
    
    // Customer endpoints
    CUSTOMERS: '/customers',
    
    // Supplier endpoints
    SUPPLIERS: '/suppliers',
    
    // Sales endpoints
    SALES_ORDERS: '/sales-orders',
    SALES_RETURNS: '/sales-returns',
    
    // Purchase endpoints
    PURCHASE_ORDERS: '/purchase-orders',
    PURCHASE_RETURNS: '/purchase-returns',
    
    // Report endpoints
    SALES_REPORT: '/reports/sales',
    PURCHASE_REPORT: '/reports/purchases',
    INVENTORY_REPORT: '/reports/inventory',
    LOW_STOCK_REPORT: '/reports/low-stock',
    INVOICE_PROFIT_LOSS_REPORT: '/reports/invoice-profit-loss',
    
    // Billing endpoints
    BILLING_REPORT_BY_DATE: '/reports/billing/by-date',
    BILLING_REPORT_BY_MONTH: '/reports/billing/by-month',
    
    // Credit endpoints
    CUSTOMER_CREDIT: '/customer-credit',
    CUSTOMER_TRANSACTIONS: '/customer-credit/transactions',
    
    // Notification endpoints
    NOTIFICATIONS: '/notifications',
    MARK_NOTIFICATION_READ: '/notifications/mark-read',
    MARK_ALL_NOTIFICATIONS_READ: '/notifications/mark-all-read',
    UNREAD_NOTIFICATIONS_COUNT: '/notifications/unread-count',
    
    // Receipt endpoints
    RECEIPT: '/receipts',
    
    // Dashboard endpoints
    DASHBOARD_SALES_CHART: '/dashboard/sales-chart',
    DASHBOARD_INVENTORY_CHART: '/dashboard/inventory-chart',
    DASHBOARD_REVENUE_TREND: '/dashboard/revenue-trend',
    DASHBOARD_TOP_CATEGORIES: '/dashboard/top-categories'
  }
};

export default API_CONFIG; 